// extracted by mini-css-extract-plugin
export default {"section":"PomodoroTimer_section__egGVY","title":"PomodoroTimer_title__xWnbR","desc":"PomodoroTimer_desc__Fec4H"};